import { Injectable } from '@angular/core';
import { createSelector, select, Store } from '@ngrx/store';
import { Map } from 'immutable';
import { map, Observable } from 'rxjs';

import { SubscriptionDatablockItemEntity } from '../components/subscription-configuration-stepper/subscription-datablock-item.entity';
import { SubscriptionProjectItemEntity } from '../components/subscription-configuration-stepper/subscription-project-item.entity';
import { ColumnConfigItemEntity } from '../domain/column-config-item.entity';
import { featureSelector, SubscriptionRootState } from './feature.store';
import {
	SubscriptionCreatorSliceKey,
	SubscriptionCreatorSliceState,
} from './subscription-creator.state';

const baseSelector = createSelector(
	featureSelector,
	(state) => state[SubscriptionCreatorSliceKey]
);

@Injectable()
export class SubscriptionCreatorSelector {
	public constructor(private readonly store: Store<SubscriptionRootState>) {}

	private get state(): Observable<SubscriptionCreatorSliceState> {
		return this.store.pipe(select(baseSelector));
	}

	public getLoading$(): Observable<boolean> {
		return this.state.pipe(map((state) => state.get('loading')));
	}

	public getShareableDatablocks$(): Observable<
		Map<string, SubscriptionDatablockItemEntity>
	> {
		return this.state.pipe(map((state) => state.get('shareableDatablocks')));
	}

	public getAvailableColumns$(): Observable<
		Map<string, ColumnConfigItemEntity>
	> {
		return this.state.pipe(map((state) => state.get('availableColumns')));
	}

	public getAvailableProjects$(): Observable<
		Map<string, SubscriptionProjectItemEntity>
	> {
		return this.state.pipe(map((state) => state.get('availableProjects')));
	}
}
